import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
    initialized: false,
    nextPage: 1,
    totalPages: 1,
    currentPage: 1
});
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'FHE_GIT__SET_ISSUES':
            return core.setIssues(state, action.issues, action.currentPage, action.nextPage, action.totalPages);
        case 'FHE_GIT__SET_ISSUE':
            return core.setIssue(state, action.issue);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./environments/fhe/data/Issues/reducer.js